var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.678,
    height: 181,
    viewBox: "0 0 118.678 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2777",
    "data-name": "Rectangle 2777",
    width: 118.678,
    height: 181,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(-11.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2776",
    "data-name": "Rectangle 2776",
    width: 118.678,
    height: 181,
    rx: 10,
    transform: "translate(11.902)",
    fill: "#cad9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M11.9,124.712v9.8l61.2,61.2L130.58,138.24V85.112L91.042,45.573Z",
    transform: "translate(0 -26.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(11.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 66.103,
    y2: 66.103,
    transform: "translate(70.94 26.956)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "6.261 6.261"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 45.606,
    y2: 45.606,
    transform: "translate(74.271 44.122)",
    fill: "none",
    stroke: "#394277",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 29.08,
    y2: 29.08,
    transform: "translate(76.181 54.114)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 21.778,
    y2: 21.778,
    transform: "translate(69.263 61.032)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 29.08,
    y2: 29.08,
    transform: "translate(62.345 67.95)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    x2: 14.092,
    y2: 14.092,
    transform: "translate(55.428 74.868)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 25.621,
    y2: 25.621,
    transform: "translate(48.51 81.785)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 6.918,
    y2: 6.918,
    transform: "translate(114.869 92.802)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 6.918,
    y2: 6.918,
    transform: "translate(107.951 99.72)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 6.918,
    y2: 6.918,
    transform: "translate(101.033 106.638)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 6.918,
    y2: 6.918,
    transform: "translate(94.116 113.556)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 6.918,
    y2: 6.918,
    transform: "translate(87.198 120.473)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x2: 66.103,
    y2: 66.103,
    transform: "translate(20.326 89.472)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "6.261 6.261"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(11.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M26.1,248.623s17.492,8.6,21.939,2.372-18.085-3.854-16.9,2.668S41.223,259,41.223,259a4.656,4.656,0,0,0,.889,5.633c2.668,2.668,6.226,3.261,8.894,4.743s2.372,7.115,3.558,8.3,7.115,4.151,7.115,1.779-3.854.3-.593,5.337,6.226,5.633,6.226,5.633",
    transform: "translate(-20.258 -145.555)",
    fill: "none",
    stroke: "#394277",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.968d96d1b95884c4e911f0c66da80af4.svg";
export { ForwardRef as ReactComponent };